module.exports = __webpack_public_path__ + "static/media/c2.d0569976.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/compliance/c2.png
// module id = 502
// module chunks = 0